<template>
    <router-view v-if="!isVPN"></router-view>
    <mobile-menu v-if="isMobile && !isVPN"></mobile-menu>
    <cookie v-if="!isVPN"></cookie>
    <Notification :show="notificationData.show" :message="notificationData.message" />

    <DisableVPN v-if="isVPN"></DisableVPN>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick, watchEffect, watch, useTemplateRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useCommonComposable } from '@/composables/commonComposable.js';
import Notification from '@/components/Notification.vue';
import Cookie from '@/components/App/cookie-bar.vue';
import MobileMenu from "@/components/App/mobile-menu.vue";

const route = useRoute();
const router = useRouter();

const { isMobile } = useCommonComposable();

import { useHead } from "@vueuse/head";
import DisableVPN from "@/components/App/DisableVPN.vue";

useHead({
    title: 'Baller Shop — магазин оригинальных джерси',
});

const notificationData = ref({
    show: false,
    message: ''
});

const isVPN = ref(false);

const fullPageHeight = ref(document.documentElement.scrollHeight + document.documentElement.clientHeight);

onMounted(() => {
    nextTick(() => {
        checkPageHeight();
        checkVPN();
    });

    window.addEventListener('resize', checkPageHeight);
});

// Функция проверки высоты страницы
const checkPageHeight = () => {
    if (isMobile.value) { return }

    const app = document.querySelector('#app');

    if (route.name === 'not-found') {
        app.style.minHeight = `${document.documentElement.clientHeight}px`;
    } else {
        app.style.minHeight = `${document.documentElement.clientHeight-269}px`;
    }
};

const checkVPN = () => {
    return
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    fetch('https://ipapi.co/json/')
        .then(response => response.json())
        .then(data => {
            console.log(data.country_name, data.timezone);

            if (data.timezone !== userTimezone) {
                console.warn("⚠️ Возможно использование VPN: Часовые пояса не совпадают!");
                isVPN.value = true;
            } else {
                console.log("✅ Часовые пояса совпадают.");
            }

            // 4. Дополнительно: Проверка по ASN (обычно это дата-центры)
            if (data.asn && data.asn.includes("VPN")) {
                console.warn("⚠️ IP адрес принадлежит VPN-провайдеру!");
                isVPN.value = true;
            }
        })
        .catch(error => console.error('Ошибка проверки IP:', error));
}

watch(
    () => route.path,
    newValue => {
        nextTick(() => {
            checkPageHeight()
        });
    }
);

watch(fullPageHeight, (newValue) => {
    if (isFinite(newValue)) {
        checkPageHeight(); // Запускаем обработку при изменении высоты
    }
}, { immediate: true }); // Немедленно выполняем при первом рендеринге

// Убираем обработчик события при уничтожении компонента
watchEffect(() => {
    return () => {
        window.removeEventListener('resize', checkPageHeight);
    };
}, { flush: 'post' });

</script>

<style src="./assets/styles/main.scss" lang="scss"></style>
